import {
  enumDriverStatus,
  enumAddressType,
} from '@rematter/frontend-lib-api-client';
import { atom } from 'jotai';

import { DriverFormState } from '~/modules/transportation/types';

const initialState: DriverFormState = {
  status: enumDriverStatus.Available,
  firstName: '',
  lastName: '',
  licenseNumber: '',
  phoneNumber: '',
  email: '',
  address: {
    streetAddress: '',
    city: '',
    state: '',
    postalCode: '',
    country: '',
    addressType: enumAddressType.Standard,
    isMailingAddress: true,
  },
};

export const $driverForm = atom<DriverFormState>(initialState);

export const $resetDriverForm = atom(null, (get, set) => {
  set($driverForm, initialState);
});

export const $updateDriverForm = atom(
  null,
  (get, set, update: Partial<DriverFormState>) => {
    const currentState = get($driverForm);
    set($driverForm, { ...currentState, ...update });
  },
);
